import React from 'react';
import ReactDOM from 'react-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { esES } from '@mui/material/locale';

// Microsoft Azure AD
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

import './index.css';
import App from './App.jsx';
import {initialState} from './contexto/initialState';
import {StateProvider} from './contexto/store';
import {mainReducer} from './contexto/reducers/';
const theme = createTheme(
  esES,
);
/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders. 
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
 export const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <React.StrictMode>
    {/* implementamos el provider */}
    <StateProvider initialState={initialState} reducer={mainReducer}>
    <ThemeProvider theme={theme}>

    <App msalInstance={msalInstance} style={{}}/>
    </ThemeProvider>;
    </StateProvider>
 
  </React.StrictMode>,
  document.getElementById('root')
);
